import { Ruleset } from "@shared/types";

const SECRETS_RULESETS = [
  "secrets-default",
  "semgrep-secrets",
  "semgrep-secrets-ai",
];

export function isSecretsRuleset(ruleset: Ruleset): boolean {
  // TODO: Switch to using ruleset.type once available
  return SECRETS_RULESETS.includes(ruleset.name);
}
